import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'

const TranslationViewTable = React.memo(({ item }) => {

    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };


    console.log("item", item);
    return (
        //    Done 
        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                <div className="card_table" style={marginTopZero}>

                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Request ID:</td>
                                    <td class="bg-primary-secondary">#{item?.transid}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requested At:</td>
                                    <td class="bg-primary-secondary">{item?.created_at && moment(item?.created_at).format(
                                        "MMM D, YYYY HH:mm:ss"
                                    )}</td>
                                </tr>
                                {/* <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Last Quote Sent:</td>
                                <td class="bg-primary-secondary">Version: {item?.quotations && item?.quotations[0]?.version}</td>
                            </tr> */}
                                {/* <tr>
                                <td class="bg-primary-secondary" style={{ width: "40%" }}>Complete Date:</td>
                                <td class="bg-primary-secondary">{item.appointment_details?.facility?.address || 'N/A'}</td>
                            </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Due Date:</td>
                                    <td class="bg-primary-secondary">{item?.translation_details?.due_date ? moment(item?.translation_details?.due_date).format(
                                        "MMM D, YYYY"
                                    ) : 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Completed Date:</td>
                                    <td class="bg-primary-secondary">{item?.status == 'Completed' && moment(item?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                                        "MMM D, YYYY HH:mm:ss"
                                    ) || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Source Language:</td>
                                    <td class="bg-primary-secondary">{item.language?.name || 'N/A'}</td>
                                </tr> */}
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Target Language:</td>
                                    <td className="bg-primary-secondary">
                                        {Array.isArray(item.translation_target_languages) && item.translation_target_languages.length > 0
                                            ? item.translation_target_languages.map(tl => tl.language?.name).filter(Boolean).join(', ')
                                            : 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Department:</td>
                                    <td class="bg-primary-secondary">{item?.department || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Source Language:</td>
                                    <td class="bg-primary-secondary">{item.language?.name || 'N/A'}</td>
                                </tr> */}
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Director, Principal, or Designee:</td>
                                    <td className="bg-primary-secondary">
                                        {item?.principal || 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Email for Director, Principal, or Designee:</td>
                                    <td class="bg-primary-secondary">{item?.translation_details?.principal_email || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div className="card_table" style={marginTopZero}>
                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                {/* <tr>
                                <td className="bg-primary-secondary" style={{ width: "40%" }}>Client: </td>
                                    <td className="bg-primary-secondary">{item?.accounts?.user?.name || 'N/A'}</td>
                                </tr> */}
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Requestor Name:</td>
                                    <td className="bg-primary-secondary">{item?.requester_name}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Requester Email:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.requester_email}</td>
                                </tr>
                                {/* <tr>
                                <td className="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.requester_phone}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Formatting Required:</td>
                                    <td class="bg-primary-secondary">{item.translation_details?.formatting ? 'Yes' : 'No'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Rush/expedited Required:</td>
                                    <td class="bg-primary-secondary">{item.translation_details?.rush ? 'Yes' : 'No'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Total Words Count:</td>
                                    <td class="bg-primary-secondary">{item?.total_words_count}</td>
                                </tr> */}
                                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Estimated Words Count:</td>
                                    <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item?.est_words_count}</td>
                                </tr> */}
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Number Of Pages:</td>
                                    <td class="bg-primary-secondary">{item?.translation_details?.pages}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Translator:</td>
                                    <td class="bg-primary-secondary">
                                        {item?.interpreter?.user?.name
                                            ? `${item.interpreter.user.name}${item?.interpreter?.employment_type === 'freelancer' ? ' (Freelancer)' : ''}`
                                            : 'N/A'}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Translator:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.provider_name || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                               
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Download Documents:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Special Instructions :</td>
                                    <td class="bg-primary-secondary">{item.translation_details?.instructions || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Document Description:</td>
                                    <td class="bg-primary-secondary">{item.translation_details?.comment || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            {(item?.status === 'Cancelled' || item?.status === 'Client Cancelled' || item?.status === 'Translator Declined') &&
                <div className="row_dash_1" style={rowDash1Style}>
                    <div className="card_table" style={marginTopZero}>

                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <table class="bg-primary-secondary table">
                                <tbody>
                                    {(item?.status === 'Cancelled' || item?.status === 'Client Cancelled') &&
                                        <>
                                            <tr>
                                                <td class="bg-primary-secondary" style={{ width: "20%" }}>Cancelled By:</td>
                                                <td class="bg-primary-secondary">{item.translation_details?.cancelled_by?.name || 'N/A'}</td>
                                                <td class="bg-primary-secondary" style={{ width: "20%" }}>Cancelled At:</td>
                                                <td class="bg-primary-secondary">{moment(item?.translation_details?.cancelled_at, "YYYY-MM-DD HH:mm:ss").format(
                                                    "MMM D, YYYY HH:mm:ss"
                                                ) || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={1} className="bg-primary-secondary" style={{ width: "20%" }}>Cancellation Reason:</td>
                                                <td colSpan={3} className="bg-primary-secondary">{item?.translation_details?.cancel_reason}</td>
                                            </tr>
                                        </>
                                    }
                                    {item?.status === 'Translator Declined' &&
                                        <tr>
                                            <td colSpan={1} className="bg-primary-secondary" style={{ width: "20%" }}>Decline Reason:</td>
                                            <td colSpan={3} className="bg-primary-secondary">{item?.translation_details?.translation_decline_reason}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>


                </div>


            }
            {item?.completed_notes && (
                <div className="row_dash_1" style={rowDash1Style}>
                    <div className="card_table" style={marginTopZero}>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <h2 style={{ fontSize: '17px', marginBottom: '12px' }}>Completion Notes:</h2>
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ whiteSpace: 'pre-wrap' }}>
                                            {item.completed_notes}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            {/* <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                        <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                    <td class="bg-primary-secondary" >{`${item.duration} minutes`}</td>
                                
                                    <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || 'N/A'}</td>
                               
                                    <td class="bg-primary-secondary">Priority Level:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.priority_level}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Encounter Source: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.encounter_source  || 'N/A'}</td>
                                
                                    <td class="bg-primary-secondary">Cancel reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                               
                                    <td class="bg-primary-secondary">Notes:</td>
                                    <td class="bg-primary-secondary">{item.appointment_assign?.notes  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Special Instructions:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.special_instruction}</td>
                                    <td class="bg-primary-secondary">DNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>  
                                    <td class="bg-primary-secondary">CNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Checkin Date:</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td>
                                    <td class="bg-primary-secondary">Checkin Time:</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || 'N/A'}</td>  
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Checkout Date:</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>
                                    <td class="bg-primary-secondary">Checkout Time:</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Comments:</td>
                                    <td class="bg-primary-secondary" colSpan={6}>{item.appointment_assign?.comments || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                </div>
            </div> */}
        </div>
    )

})

export default TranslationViewTable